function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.68954 25H18.3203C20.7126 25 22.6588 23.0538 22.6588 20.6615V7.69231C22.6588 7.26923 22.3126 6.92308 21.8895 6.92308H17.2742V5.76923C17.2742 2.58846 14.6857 0 11.5049 0C8.32415 0 5.73569 2.58846 5.73569 5.76923V6.92308H1.1203C0.697228 6.92308 0.351074 7.26923 0.351074 7.69231V20.6615C0.351074 23.0538 2.29723 25 4.68954 25ZM7.27415 5.76923C7.27415 3.43462 9.1703 1.53846 11.5049 1.53846C13.8395 1.53846 15.7357 3.43462 15.7357 5.76923V6.92308H7.27415V5.76923ZM1.88954 8.46154H5.73569V10.3846C5.73569 10.8077 6.08184 11.1538 6.50492 11.1538C6.928 11.1538 7.27415 10.8077 7.27415 10.3846V8.46154H15.7357V10.3846C15.7357 10.8077 16.0818 11.1538 16.5049 11.1538C16.928 11.1538 17.2742 10.8077 17.2742 10.3846V8.46154H21.1203V20.6615C21.1203 22.2038 19.8626 23.4615 18.3203 23.4615H4.68954C3.14723 23.4615 1.88954 22.2038 1.88954 20.6615V8.46154Z",
  fill: "white"
});

function SvgHeaderBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBag);
export default __webpack_public_path__ + "static/media/header_bag.37644e13.svg";
export { ForwardRef as ReactComponent };